import React, { useState } from "react";
import styled from "styled-components/macro";
import {
  Avatar,
  Chip as MuiChip,
  Paper as MuiPaper,
  Dialog,
  Box,
  DialogActions,
  Button,
  Typography,
} from "@material-ui/core";
import {
  CheckCircleOutline as CheckCircleOutlineIcon,
  HighlightOff as HighlightOffIcon,
  WifiTethering as WifiTetheringIcon,
} from "@material-ui/icons";
import RouterIcon from "@material-ui/icons/Router";
import { green, orange, red } from "@material-ui/core/colors";
import { spacing } from "@material-ui/system";
import MaterialTable from "material-table";
import { getAllAPNodes } from "../services/apServices";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import ApRegistrationWizard from "./mantenimiento-ap/ApRegistrationWizard";
import MapBoxMap from "../components/MapBox";

const Paper = styled(MuiPaper)`
  ${spacing};

  border-radius: 22px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.06);
  overflow: hidden;
`;
const Chip = styled(MuiChip)`
  ${spacing};

  background: ${(props) => props.verde && green[500]};
  background: ${(props) => props.naranja && orange[700]};
  background: ${(props) => props.rojo && red[500]};
  color: ${(props) => props.theme.palette.common.white};
`;

const SummaryStrip = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 14px;
  padding: 20px 20px 0;
`;

const SummaryCard = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  border-radius: 18px;
  padding: 16px;
  background: ${(props) => props.background || "#f8fafc"};
  border: 1px solid rgba(148, 163, 184, 0.14);
`;

const ModalHero = styled.div`
  padding: 24px 24px 18px;
  background: linear-gradient(135deg, #0f2948 0%, #1d4e89 58%, #67b5de 100%);
  color: #fff;
`;

const DialogScrollBody = styled.div`
  max-height: calc(100vh - 72px);
  overflow-y: auto;
  overflow-x: hidden;

  scrollbar-width: thin;
  scrollbar-color: rgba(29, 78, 137, 0.55) rgba(226, 232, 240, 0.9);

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(226, 232, 240, 0.9);
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(29, 78, 137, 0.55);
    border-radius: 999px;
    border: 2px solid rgba(226, 232, 240, 0.9);
  }
`;

export default function APMaintenanceTable() {
  const [dataTable, setDataTable] = useState([]);
  const tableRef = React.createRef();
  const [openWizard, setOpenWizard] = useState(false);
  const [rowAP, setRow] = useState(null);
  const [openMap1, setOpenMap1] = useState(false);
  const [auxlocation, setAuxLocation] = useState({ latitude: 0, longitude: 0 });

  const handleCloseWizard = () => {
    setOpenWizard(false);
  };

  const handleOpenWizard = (rowData) => {
    setOpenWizard(true);
    setRow(rowData);
  };

  let getTableData = async () => {
    getAllAPNodes().then((res) => {
      setDataTable(res.data);
    });
  };

  React.useEffect(() => {
    getTableData();
  }, []);

  const onlineCount = dataTable.filter(
    (row) => row.accessPointInfo.apAlive === "Online"
  ).length;
  const offlineCount = dataTable.length - onlineCount;
  const totalPendingConnections = dataTable.reduce(
    (total, row) => total + Number(row.accessPointInfo.vouchersCount || 0),
    0
  );

  function EditForm() {
    return (
      <React.Fragment>
        <Dialog
          open={openWizard}
          onClose={handleCloseWizard}
          maxWidth="md"
          fullWidth
          scroll="paper"
          PaperProps={{
            style: {
              borderRadius: 28,
              overflow: "hidden",
              maxHeight: "calc(100vh - 32px)",
            },
          }}
        >
          <DialogScrollBody>
            <ApRegistrationWizard editing={true} dataAP={rowAP} />
            <DialogActions style={{ padding: "0 24px 24px" }}>
              <Button onClick={handleCloseWizard} color="primary">
                Cerrar
              </Button>
            </DialogActions>
          </DialogScrollBody>
        </Dialog>
      </React.Fragment>
    );
  }

  function MapAPLocation() {
    return (
      <Dialog
        open={openMap1}
        onClose={() => setOpenMap1(false)}
        aria-labelledby="form-dialog-title"
        closeonescape="false"
        maxWidth="lg"
        fullWidth={true}
        scroll="body"
        PaperProps={{
          style: {
            borderRadius: 28,
            overflow: "hidden",
            background: "linear-gradient(180deg, #f8fbff 0%, #f3f7fb 100%)",
          },
        }}
      >
        <ModalHero>
          <Typography variant="overline" style={{ opacity: 0.75 }}>
            Geolocalizacion del AP
          </Typography>
          <Typography variant="h4">Ubicacion del access point</Typography>
          <Typography variant="body2" style={{ opacity: 0.9, maxWidth: 640 }}>
            Revisa la referencia exacta del punto sobre el mapa antes de cerrar
            la consulta.
          </Typography>
        </ModalHero>
        <Box px={3} pt={3} pb={1}>
          <Typography variant="body2" color="textSecondary">
            Coordenadas activas: {auxlocation.latitude}, {auxlocation.longitude}
          </Typography>
        </Box>
        <Box px={2} pb={1}>
          <MapBoxMap coordinates={auxlocation}></MapBoxMap>
        </Box>
        <DialogActions style={{ padding: "12px 24px 24px" }}>
          <Button
            onClick={() => {
              setOpenMap1(false);
            }}
            variant="contained"
            color="primary"
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <Paper>
      <EditForm />
      <MapAPLocation />
      <SummaryStrip>
        <SummaryCard background="linear-gradient(135deg, rgba(14, 165, 233, 0.14), rgba(37, 99, 235, 0.16))">
          <Avatar style={{ background: "#1d4ed8" }}>
            <RouterIcon />
          </Avatar>
          <div>
            <Typography variant="caption" color="textSecondary">
              Access points
            </Typography>
            <Typography variant="h5">{dataTable.length}</Typography>
          </div>
        </SummaryCard>
        <SummaryCard>
          <Avatar style={{ background: "#15803d" }}>
            <CheckCircleOutlineIcon />
          </Avatar>
          <div>
            <Typography variant="caption" color="textSecondary">
              Online
            </Typography>
            <Typography variant="h5">{onlineCount}</Typography>
          </div>
        </SummaryCard>
        <SummaryCard>
          <Avatar style={{ background: "#dc2626" }}>
            <HighlightOffIcon />
          </Avatar>
          <div>
            <Typography variant="caption" color="textSecondary">
              Offline
            </Typography>
            <Typography variant="h5">{offlineCount}</Typography>
          </div>
        </SummaryCard>
        <SummaryCard>
          <Avatar style={{ background: "#7c3aed" }}>
            <WifiTetheringIcon />
          </Avatar>
          <div>
            <Typography variant="caption" color="textSecondary">
              Conexiones pendientes
            </Typography>
            <Typography variant="h5">{totalPendingConnections}</Typography>
          </div>
        </SummaryCard>
      </SummaryStrip>
      <MaterialTable
        title=""
        tableRef={tableRef}
        data={dataTable}
        options={{
          grouping: false,
          actionsColumnIndex: -1,
          tableLayout: "auto",
          search: true,
          pageSize: 5,
          pageSizeOptions: [5, 10, 20],
          headerStyle: {
            backgroundColor: "#f8fbff",
            color: "#475569",
            fontSize: "0.72rem",
            fontWeight: 800,
            textTransform: "uppercase",
            letterSpacing: "0.08em",
          },
          rowStyle: (rowData, index) => ({
            backgroundColor: index % 2 === 0 ? "#ffffff" : "#fbfdff",
          }),
          searchFieldStyle: {
            borderRadius: 999,
            backgroundColor: "#f8fafc",
            padding: "8px 14px",
          },
        }}
        localization={{
          body: {
            emptyDataSourceMessage: "No hay access points registrados.",
          },
          header: {
            actions: "Acciones",
          },
          toolbar: {
            searchPlaceholder: "Buscar access point",
          },
        }}
        columns={[
          {
            title: "Nombre del AP",
            field: "accessPointInfo.name",
            cellStyle: {
              textAlign: "left",
            },
            headerStyle: {
              textAlign: "left",
            },
          },
          {
            title: "Categoría",
            field: "accessPointInfo.category",
            cellStyle: {
              textAlign: "left",
            },
            headerStyle: {
              textAlign: "left",
            },
          },
          {
            title: "Conexiones Pendientes",
            field: "accessPointInfo.vouchersCount",
            cellStyle: {
              textAlign: "left",
            },
            headerStyle: {
              textAlign: "left",
            },
          },
          {
            title: "Tipo",
            field: "accessPointInfo.status",
            cellStyle: {
              textAlign: "left",
            },
            headerStyle: {
              textAlign: "left",
            },
          },
          {
            title: "Estado",
            field: "accessPointInfo.apAlive",
            cellStyle: { textAlign: "left" },
            headerStyle: { textAlign: "left" },
            render: (rowData) => (
              <Chip
                label={rowData.accessPointInfo.apAlive}
                style={{
                  backgroundColor:
                    rowData.accessPointInfo.apAlive === "Online"
                      ? "#4caf50"
                      : "#f44336",
                  color: "#fff",
                  fontWeight: "bold",
                }}
                size="small"
              />
            ),
          },
        ]}
        actions={[
          {
            icon: () => <LocationOnIcon />,
            tooltip: "Ubicar",
            onClick: (event, rowData) => {
              setAuxLocation({
                latitude: rowData.accessPointInfo.latitude,
                longitude: rowData.accessPointInfo.longitude,
              });
              setOpenMap1(true);
            },
          },
          (rowData) => ({
            icon: "edit",
            tooltip: "Editar",
            onClick: (event, rowData) => {
              handleOpenWizard(rowData.accessPointInfo);
            },
            disabled: rowData.accessPointInfo.vouchersCount > 0,
          }),
        ]}
      />
    </Paper>
  );
}
